import { Component, DestroyRef, Input, OnChanges, OnInit, ViewChild, inject } from '@angular/core';
import { Company, Damage, Smartphoto } from '@bdeo-motor/smartphoto-entities';
import { TransactionService } from '../../../services/transaction.service';
import { SmartphotoService } from '../../../services/smartphoto.service';
import { SmartphotoStatusDetails } from 'src/app/entities/types/smartphoto-status-details.type';
import { MiscService } from '../../../services/misc.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SmartphotoSendReportDrawerComponent } from './smartphoto-send-report-drawer/smartphoto-send-report-drawer.component';
import { SmartphotoReviewDrawerComponent } from '../../smartphoto-review-drawer/smartphoto-review-drawer.component';
import { LogOutDialog } from '../../../components/navbar/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-smartphoto-footer',
  templateUrl: './smartphoto-footer.component.html',
  styleUrls: ['./smartphoto-footer.component.scss']
})
export class SmartphotoFooterComponent implements OnInit, OnChanges {
  @Input({ required: true }) public smartphoto?: Smartphoto;
  @Input({ required: true }) public company?: Company;

  @ViewChild(SmartphotoSendReportDrawerComponent) protected drawer!: SmartphotoSendReportDrawerComponent;
  @ViewChild(SmartphotoReviewDrawerComponent) public reviewDrawer?: SmartphotoReviewDrawerComponent;

  protected readonly transactionService = inject(TransactionService);
  protected readonly smartphotoService = inject(SmartphotoService);
  private readonly miscService = inject(MiscService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);

  protected statusDetails?: SmartphotoStatusDetails;
  protected actionsDamage?: Damage;
  public galleryIsActive$ = this.miscService.galleryActive$;
  public secondaryActionsIsActive$ = this.miscService.secondaryActionsActive$;
  public images$ = this.smartphotoService.get.images();

  public ngOnInit(): void {
    this.smartphotoService.actionsDamageObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((damage) => {
      this.actionsDamage = damage;
    });
  }

  public async downloadImages(): Promise<void> {
    await this.smartphotoService.downloadImages();
  }

  public closeSecondaryActions(): void {
    this.miscService.toggleSecondaryActions();
  }

  public openSendReportDrawer(): void {
    this.closeSecondaryActions();
    this.drawer.open();
  }

  public ngOnChanges(): void {
    this.statusDetails = this.smartphotoService.getSmartphotoStatusDetails(this.smartphoto);
  }

  public cancelTransaction(): void {
    this.transactionService.cancel();
    this.smartphotoService.resetSmartphoto();
  }

  public downloadReport(): void {
    window.open(this.smartphotoService.getSmartphotoReport(), '_blank');
  }

  public goToEvidenceCapture(): void {
    window.open(this.smartphotoService.getEvidenceCaptureLink(), '_self');
  }

  public goToAdditionals(): void {
    window.open(this.smartphotoService.getAdditionalsLink(), '_blank');
  }

  public reviewSmartphoto(): void {
    this.reviewDrawer?.open();
  }

  public async openLogOutDialog(): Promise<void> {
    const isSecondaryActionActive = await firstValueFrom(this.miscService.secondaryActionsActive$);

    if (isSecondaryActionActive) {
      this.miscService.toggleSecondaryActions();
    }

    this.dialog.open(LogOutDialog, {
      width: 'calc(100% - 40px)',
      maxWidth: '600px'
    });
  }
}
